import AbstractWebSocket from '@/utils/abstractWebSocket';
import io from 'socket.io-client';

// 系统休眠检测的时间差， 2次状态检测的时间差达到3分钟时候，即判定当前系统休眠
const breakDuration = 1000 * 60 * 3;
export default class Websocket extends AbstractWebSocket {
  reconnecting = false;
  bufferEventMap = new Map();
  bufferEmitSet = new Set();
  query = {}

  get isClosed() {
    return this.instance?.disconnected;
  }

  get isConnected() {
    return this.instance?.connected;
  }

  get isConnecting() {
    return this.instance?.io?.readyState === 'opening';
  }

  connect(url, options = {}) {
    console.log(url, options, '--ws----connect-', this.isConnected);
    if (this.isConnected) {
      return this;
    }
    const { query, path = '/socket.io', namespace = '' } = options;
    this.url = `${url}/${namespace}`.replace(/[/]+[/]/g, '/').replace(':/', '://');
    this.query = query || {};
    this.path = path;
    this.create();
    return this;
  }

  create() {
    if (this.isConnected || this.isConnecting) {
      return;
    }
    const { url, query, path } = this;
    if (this.instance) {
      this.instance.close();
    }
    console.log('建立链接');
    this.instance = io(url, { query, path, transports: ['websocket'], timeout: 5000, reconnectionDelayMax: 1000 * 60 * 5 });
    this.instance?.on('connect', this.onConnected.bind(this));
    this.instance?.on('disconnect', this.onDisconnect.bind(this));
    this.instance?.on('connect_error', this.onConnectError.bind(this));
    this.instance?.on('action', this.onActionMessage.bind(this));
    this.flashBufferEvent();
    this.checkCheckConnectStatus(true);
  }
  checkCheckConnectStatus(isInit) {
    if (this.lastActiveTime && (+new Date() - this.lastActiveTime > breakDuration)) {
      this.breakPoint = this.lastActiveTime;
    }
    this.lastActiveTime = +new Date();
    
    if (this.instance && !this.instance.connected && !isInit) {
      if (self.navigator.onLine) {
        this.instance.io?.reconnection(true);
        this.instance.io?.open();
      }
    }
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.checkCheckConnectStatus();
    }, 5000);
  }

  flashBufferEvent() {
    for (const [key, value] of this.bufferEventMap) {
      value.forEach(fn => this.on(key, fn));
    }
  }

  flashBufferEmit() {
    this.bufferEmitSet.forEach(item => {
      const [event, content] = item;
      this.emit(event, content);
      this.bufferEmitSet.delete(item);
    });
  }

  on(event, fn) {
    const [ type, name ] = event.split(':');
    if (type === 'global') {
      if (!this.instance) {
        const fnSet = this.bufferEventMap.get(event);
        if (!fnSet) {
          this.bufferEventMap.set(event, new Set());
          return this.on(event, fn);
        }
        if (!fnSet.has(fn)) {
          fnSet.add(fn);
        }
        return this;
      }
      this.instance.on(name, fn);
      return this;
    }
    return super.on(event, fn);
  }

  off(event, fn) {
    const [ type, name ] = event.split(':');
    if (type === 'global') {
      const fnSet = this.bufferEventMap.get(event);
      if (fnSet) {
        fnSet.delete(fn);
      }
      this.instance?.off(name, fn);
      return this;
    }
    return super.off(event, fn);
  }

  onConnected() {
    this.reconnecting = false;
    console.info(`ws ${this.url}${this.path} 连接成功`, Date.now());
    this.flashBufferEmit();
    if (this.breakPoint) {
      const duration = Date.now() - this.breakPoint;
      if (typeof this.saveBreakPoint === 'function') {
        this.saveBreakPoint(this.breakPoint, duration, Date.now());
      }
      this.breakPoint = null;
    }
  }

  onDisconnect() {
    console.info(`ws ${this.url}${this.path} 断开连接`, Date.now());
  }
  onConnectError(e) {
    console.log(`ws ${this.url}${this.path} error`, e);
  }

  onActionMessage() {
    console.log('--onActionMessage--');
  }

  emit(event, content) {
    if (!this.isConnected) {
      this.bufferEmitSet.add([event, content]);
      return this;
    }
    this.instance?.emit(event, content);
  }

  parseData(e) {
    const { data } = e;
    if (!data) {
      return null;
    }
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  }

  offline() {
    super.offline();
    if (this.instance) {
      console.info(`ws ${this.url}${this.path} 离线, 暂停重连`, Date.now());
      this.instance.io?.reconnection(false);
    }
  }

  online() {
    super.online();
    if (this.instance) {
      console.info(`ws ${this.url}${this.path} 在线, 启用重连`, Date.now());
      this.instance.io?.reconnection(true);
      this.instance.io?.open();
    }
  }
  clear(){
    this.instance?.close();
    this.bufferEventMap.clear();
    this.bufferEmitSet.clear();
  }
  destroy() {
    super.destroy();
    this.instance?.close();
    this.bufferEventMap.clear();
    this.bufferEventMap = null;
    this.bufferEmitSet.clear();
    this.bufferEmitSet = null;
    clearTimeout(this.timer);
  }
}
